import { jwtDecode } from 'jwt-decode';

export interface DecodedToken {
  email: string;
  name?: string;
  key?: string;
  sub?: string;
  [key: string]: any;
}

export function getDecodedToken(): DecodedToken | null {
  const token = localStorage.getItem('auth_app_token');
  if (!token) return null;

  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    console.error('Erro ao decodificar o token', error);
    return null;
  }
}
